import { PageResponseVm } from 'api/core/page-response.vm';
import { Type } from 'class-transformer';
import { IsString, ValidateNested } from 'class-validator';
import { SerialNumberVm } from './serial-number.vm';

export class GetProductSerialNumbersVm extends PageResponseVm<SerialNumberVm, string> {
  @IsString()
  nextOffset: string | null;

  @ValidateNested({ each: true })
  @Type(() => SerialNumberVm)
  objects: SerialNumberVm[];
}
